// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ifZ1","textarea":"styles_textarea__3XA8n"};